export default __webpack_public_path__ + "db73f8948d8bbd38aa474e241f17f899.webp";